/**
 * Push resource — VAPID public key + browser Web Push subscription register/drop.
 *
 * The dashboard fetches the VAPID key, subscribes via the browser Push API, and POSTs the
 * resulting subscription on login; it DELETEs it on logout. See `dashboard/src/push/pushClient`.
 */

import type { HttpClient } from '../httpClient';
import { endpoints } from '../endpoints';

/** The browser `PushSubscription.toJSON()` shape the backend accepts (endpoint + public keys). */
export interface PushSubscriptionInput {
  endpoint: string;
  keys: { p256dh: string; auth: string };
}

export class PushResource {
  constructor(private readonly http: HttpClient) {}

  /** The server's VAPID public key (`applicationServerKey`); empty string ⇒ push disabled. */
  vapidPublicKey(): Promise<{ publicKey: string }> {
    return this.http.get(endpoints.push.vapidKey());
  }

  /** Register (or refresh) a browser Push subscription for the current agent. */
  subscribe(input: PushSubscriptionInput): Promise<void> {
    return this.http.post(endpoints.push.subscriptions(), input);
  }

  /** Drop a subscription by its endpoint (logout / permission revoke). */
  unsubscribe(endpoint: string): Promise<void> {
    return this.http.delete(endpoints.push.subscriptions(), { body: { endpoint } });
  }
}
